export const TAB_STATE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERITARY: 'teritary',
};

export const TAB_LIST = [
  {label: 'Predicted', value: 'predicted', state: TAB_STATE.PRIMARY, altText: "Predicted results."},
  {label: 'Actual', value: 'actual', state: TAB_STATE.SECONDARY, altText: "Actual results."},
  {label: 'Ideal', value: 'ideal', state: TAB_STATE.TERITARY, altText: "Ideal results."},
];
